import type { AppState } from '@store/types'
import cx from 'classnames'
import type React from 'react'
import { useSelector } from 'react-redux'

import { getDragAndDropAttributes } from '../DragAndDrop/getDragAndDropAttributes'
import { DRAGGABLE_TYPE, DROPZONE_TYPE } from '../DragAndDrop/types'
import css from './Blocks.module.scss'

const BlockDropzone: React.FC<{ id: string; blockId: string; data: any }> = ({
  id,
  blockId,
  data,
}) => {
  const isOver = useSelector<AppState, boolean>(
    ({ artboard }) =>
      id === artboard.dragAndDrop.dropZone.id &&
      // @ts-expect-error
      !artboard.dragAndDrop.dragged.id.includes(blockId) &&
      (artboard.dragAndDrop.dragged.type === DRAGGABLE_TYPE.BLOCK ||
        artboard.dragAndDrop.dragged.type === DRAGGABLE_TYPE.SYMBOL)
  )

  return (
    <div
      className={cx(css.dropzone, {
        [css.dropzoneActive]: isOver,
      })}
      {...getDragAndDropAttributes(id, DROPZONE_TYPE.BLOCK, data)}
    >
      <div />
    </div>
  )
}

export default BlockDropzone
